<template>
  <div>

    <ImageView v-if="entity.image" :src="entity.image" :desc="entity.imageDesc"></ImageView>

    <div>
      {{entity.subject}} ({{entity.answerSubject}})
    </div>

    <AudioView :src="entity.audio" :caption="entity.audioText" :caption-pinyin="entity.audioPinyin"></AudioView>

    <div class="items flex-row flex-wrap">
      <div v-for="(item, key) in entity.items" :key="key" class="flex-row align-items-center">
        <div>
          {{key + 1}}.&nbsp;
        </div>
        <div>
          {{item.tone}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ImageView from './../../ImageView'
import AudioView from './../../AudioView'

export default {
  name: 'XsdView',
  components: { ImageView, AudioView },
  props: {
    type: {
      type: Object,
      default: () => {
        return {}
      }
    },
    entity: {
      type: Object,
      default: () => {
        return {}
      }
    },
    theme: {
      type: String,
      default: 'card'
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="scss">
  .exr-xsd{
    .items{
      margin: -5px;
      > div{
        margin: 5px;
      }
    }
  }
  .exr-theme-line{
    >.exr-content{
      display: flex;
      align-items: center;
      > div + div {
        margin-left: 5px;
      }
    }
    img{
      max-height: 50px;
    }
  }
</style>
